export default function CapabilitiesSection() {
  return (
    <section className="bg-background-50 py-20 md:py-28 px-8 md:px-16">
      <div className="text-center mb-16 md:mb-24">
        <h2 className="text-4xl md:text-5xl font-heading text-foreground-950 tracking-tight">
          Engineering Capabilities
        </h2>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
        <div className="relative aspect-[4/5] rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20fine%20geometric%20grid%20lines%20texture%2C%20minimalist%20monochromatic%20pattern%2C%20desaturated%20charcoal%20and%20silver%20tones%2C%20clean%20architectural%20grid%2C%20no%20text%2C%20subtle%20mathematical%20precision%2C%20dark%20minimal%20design%2C%20high%20contrast%20line%20art%20style&width=600&height=700&seq=card-bg-01&orientation=portrait"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-foreground-950/55"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <h3 className="text-xl md:text-2xl font-heading text-background-50 mb-3">
              Clean Architecture
            </h3>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed max-w-[240px]">
              Modular, maintainable systems with clear separation of concerns and long-term scalability.
            </p>
          </div>
        </div>

        <div className="relative aspect-[4/5] rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20circuit%20like%20traces%20and%20pathways%2C%20minimalist%20technical%20pattern%2C%20desaturated%20charcoal%20and%20silver%20tones%2C%20no%20text%2C%20clean%20geometric%20arrangement%2C%20dark%20minimal%20design%2C%20technology%20inspired%20abstract%20art%2C%20subtle%20node%20connections&width=600&height=700&seq=card-bg-02&orientation=portrait"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-foreground-950/55"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <h3 className="text-xl md:text-2xl font-heading text-background-50 mb-3">
              Performance Optimization
            </h3>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed max-w-[240px]">
              Fast, responsive, and efficient software delivering seamless user experiences at every level.
            </p>
          </div>
        </div>

        <div className="relative aspect-[4/5] rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20brushed%20metallic%20gradient%20texture%2C%20minimalist%20monochromatic%20surface%2C%20desaturated%20charcoal%20and%20silver%20tonal%20gradation%2C%20no%20text%2C%20smooth%20industrial%20finish%2C%20dark%20minimal%20design%2C%20subtle%20light%20reflection%2C%20matte%20to%20satin%20transition&width=600&height=700&seq=card-bg-03&orientation=portrait"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-foreground-950/55"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <h3 className="text-xl md:text-2xl font-heading text-background-50 mb-3">
              User-Centered Design
            </h3>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed max-w-[240px]">
              Intuitive, accessible interfaces crafted around real user needs and thoughtful interaction design.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}